{
  "version": 1,
  "asset_id": "76d41fd7-f9d7-48ab-b20d-14dba0161107",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/76d41fd7-f9d7-48ab-b20d-14dba0161107/ss01-card-n1.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/76d41fd7-f9d7-48ab-b20d-14dba0161107/ss01-card-n1.webp",
  "original_filename": "ss01-card-n1.webp",
  "size": 99780,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:28Z"
}
